module.exports = __webpack_public_path__ + "assets/img/mecha-a6a73246.png";